import { render } from "./FormClientView.vue?vue&type=template&id=42feb708"
import script from "./FormClientView.vue?vue&type=script&lang=js"
export * from "./FormClientView.vue?vue&type=script&lang=js"

import "./FormClientView.vue?vue&type=style&index=0&id=42feb708&lang=css"

import exportComponent from "/builds/proximis/page_abonnement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__